import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { getTranscriptionsEnabled } from '../../../redux/modules/auth';
import { VpTranscriptionBadge, VpInput, VpUpgradePromptBox, VpIcon } from '../..';

const boxStyles = {
  mb: 4 // 20px
};

const VpMediaTranscriptionInput = ({ media, isFeatureEnabled, ...rest }) => {
  if (!isFeatureEnabled) {
    return (
      <Box sx={boxStyles}>
        <Typography variant="inputLabel">
          Transcription <VpIcon icon="Lock" />
        </Typography>
        <VpUpgradePromptBox
          title="Auto Transcription"
          description="Upgrade to automatically get fully transcripted videos"
        />
      </Box>
    );
  }

  return (
    <VpInput
      disabled
      maxLength={500}
      multiline
      rows={5}
      name="transcription"
      label={
        <Stack direction="row" gap="5px" alignItems="center">
          Transcription <VpTranscriptionBadge transcriptionStatus={media?.transcriptionStatus} />
        </Stack>
      }
      canCopy
      value={media?.transcription}
      {...rest}
    />
  );
};

VpMediaTranscriptionInput.propTypes = {
  isFeatureEnabled: PropTypes.bool,
  media: PropTypes.shape({
    transcriptionStatus: PropTypes.string,
    transcription: PropTypes.string
  })
};

const mapStateToProps = (state) => ({
  isFeatureEnabled: getTranscriptionsEnabled(state)
});

export default connect(mapStateToProps)(VpMediaTranscriptionInput);



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/media-details/VpMediaTranscriptionInput.jsx